import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
  PuObrazacListPayload,
  PuObrazac,
} from "../../modules/poreskaUprava/poreskaUprava.types";

import FilterableTableLayout from "../../components/FilterableTableLayout/FilterableTableLayout";
import {
  getPUObrasciFilterItems,
  getPuObrasciTableColumns,
  PU_OBRASCI_LIST_INITIAL_FILTERS,
} from "../../modules/poreskaUprava/poreskaUprava.constants";
import { PersistedFilterKeys } from "../../modules/filters/filters.types";
import { usePuObrasciList } from "../../modules/poreskaUprava/poreskaUprava.queries";
import { authService } from "../../modules/auth/auth.service";

export const PuObrasciPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isMfin = authService.getRole().some((role) => role.includes("MFIN"));

  const onTableRowClick = (puObrazac: PuObrazac) => {
    navigate(`detaljiObrasca?id=${puObrazac.id}`);
  };

  return (
    <FilterableTableLayout<PuObrazac, PuObrazac[], PuObrazacListPayload>
      tableName="pu_obrasci_table"
      toolbarId="pu_obrasci_page"
      title={t("PU_OBRASCI.PODACI_O_IZVRSENOM_UVOZU")}
      filterProps={{
        getFilterItems: () =>
          getPUObrasciFilterItems({ hiddenFilters: isMfin ? [] : ["pib"] }),
        initialFilters: PU_OBRASCI_LIST_INITIAL_FILTERS,
        persistedFilterKey: PersistedFilterKeys.PU_OBRASCI_LIST,
      }}
      getTableColumns={() =>
        getPuObrasciTableColumns({
          hiddenColumns: isMfin ? [] : ["pibUvoznika"],
        })
      }
      queryHook={usePuObrasciList}
      tableRowKey="id"
      onTableRowClick={onTableRowClick}
    />
  );
};
